import AddTokenToOptions from '../../../AddTokenToOptions';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const SearchForStock: any = async (searchTerm: string) => {
  const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;
  const stockApiBaseUrl = `${backendUrl}/eod-proxy/search/`;

  const apiKey = process.env.REACT_APP_STOCK_API_KEY;

  const error = new Error('Something went wrong');

  const response = await fetch(
    `${stockApiBaseUrl}${searchTerm}?api_token=${apiKey}&limit=15`,
    await AddTokenToOptions({ mode: 'cors' }),
  );

  if (response.status == 200) {
    const result = await response.json();

    return result.map((item: any) => {
      return {
        name: item.Name,
        symbol: `${item.Code}.${item.Exchange}`,
        market: item.Exchange,
      };
    });
  } else {
    throw error;
  }
};
